import React from 'react'
import { NavLink } from 'react-router-dom'

import SendGTAGEvent from '../../utils/sendGTAGEvent';
import { Container } from './styles'

interface IHeaderNavigationItemProps {
    label: string;
    to: string;
}

const HeaderNavigationItem: React.FC<IHeaderNavigationItemProps> = ({ label, to }) => (
    <Container onClick={() => {
        to === '/my-wishlists' ?
            SendGTAGEvent(
                'navegacao_minhas_lojinhas',
                'Navegação',
                'Usuário acessou "Minhas Lojinhas"',
            ) :
            SendGTAGEvent(
                'navegacao_produtos',
                'Navegação',
                'Usuário acessou "Produtos"',
            )
    }}>
        <NavLink to={to} className={(navData) => navData.isActive ? 'a__navlink--active' : 'a__navlink--disabled'} >
            {label}
        </NavLink>
    </Container>
)


export default HeaderNavigationItem